
/*
 * find float and integer
 */
const REGEX_NUM = /[+-]?\d+(\.\d+)?/g; 

/*
 * find all characters
 */
const REGEX_CHAR = /[A-Z]+/gi;

/*
 * calculate max - min consumption data value of given models
 * @field the consumption data field
 * @models the consumption data of the different models
 * @return empty string if no value, one value if max and min are same, max to min if two values given
 */
export const calcValues = (field, models) => {
    const max = []; // max values of all models
    const min = []; // min values of all models
    let values,     // tmp array holds max and min of one model
    maxValue,       // max of all max values
    minValue,       // min of all min values
    str;            // output
    
    models.forEach(model => {
        if(model[field]) {
            // create correct numbers in string (replace)
            // find all numbers (match)
            // get the numbers (map)
            values = model[field].replace(/,/g, '.').match(REGEX_NUM).map(value => { 
                return parseFloat(value);
            });
            
            if(values.length) {
                if(values.length > 1) {
                    max.push(values[0]);
                    min.push(values[1]);
                } else {
                    max.push(values[0]);
                    min.push(values[0]);
                }
            }
        }
    });
    
    if(!max.length || !min.length) {
        return "";
    }
    
    maxValue = Math.max( ...max );
    minValue = Math.min( ...min );
    str = maxValue !== minValue ?  maxValue + " - " + minValue : maxValue+"";
    
    return str.replace(/\./g, ',');
}

export const calcPlakette = (models) => {
    const cls = [];
    let values,
    maxValue,       // max of all max values
    minValue;       // min of all min values
    
    models.forEach(model => {
        if(model.Energieklasse) {
            values = model.Energieklasse.match(REGEX_CHAR);
            
            cls.push( ...values );
        }
    });
    
    if(!cls.length) {
        return "";
    }
    
    cls.sort()
    maxValue = cls[cls.length-1];
    minValue = cls[0];
    
    return maxValue !== minValue ?  maxValue + " - " + minValue : maxValue;
}

export const getType = (consumptions) => {
    let type = "";
    
    for(let key in consumptions) {
        if(type !== "span") {
            type = consumptions[key].Typ;
        }
    }
    
    return type;
}

/*
export const getConsumptions = (id, consumptions) => {
    const values = {};
    
    if(consumptions.content) {
        consumptions.content.elements.forEach((elm, index) => {
            //if(elm.Vorlage.indexOf("baureihe") !== -1){ console.log(this.props.id, elm.PMDb_IDs, elm.Modell, elm.Bezeichnung_1, "(index:"+index+")");}    
            //if(!elm.PMDb_IDs.length){ console.log(this.props.id, elm.PMDb_IDs, elm.Modell, elm.Bezeichnung_1, "(index:"+index+")");}
            
            if(elm.PMDb_IDs.includes(parseInt(id)) && elm.Vorlage.indexOf("baureihe") === -1) {
                values[elm.Typ] = elm;
            }
        });
    }
    
    return values;
}
*/
export const showType = (consumptions) => {
    const values = [];
    
    if(consumptions.content) {
        consumptions.content.elements.forEach((elm, index) => {
           
            !values.includes(elm.Typ) && values.push(elm.Typ);
            
        });
    }
    
    console.log(values);
}

export const showCombi = (consumptions) => {
    const values = [];
    
    if(consumptions.content) {
        consumptions.content.elements.forEach((elm, index) => {
           
            !values.includes(elm.Typ + "_" + elm.Vorlage) && values.push(elm.Typ + "_" + elm.Vorlage);
            
        });
    }
    
    console.log(values);
}

export const showVorlage = (consumptions) => {
    const values = [];
    
    if(consumptions.content) {
        consumptions.content.elements.forEach((elm, index) => {
           
            !values.includes(elm.Vorlage) && values.push(elm.Vorlage);
            
        });
    }
    
    console.log(values);
}

export const findCombi = (consumptions, Typ, Vorlage) => {
    const values = [];
    console.log(Typ, Vorlage);
    if(consumptions.content) {
        consumptions.content.elements.forEach((elm, index) => {
           
            if(elm.Typ === Typ && elm.Vorlage === Vorlage) {
				values.push({name: elm.Bezeichnung_1, elm: elm});
			}
            
        });
    }
    
    console.log(values);
}

/*
export const createRange = (range, consumptions, type) => {
    const models = [];
    
    if(range && consumptions.content) {
        range.RANGE.forEach(id => {
            consumptions.content.elements.forEach((elm, index) => {
                if(elm.PMDb_IDs.includes(parseInt(id)) && elm.Vorlage.indexOf("baureihe") === -1 && elm.Typ === type) {
                    models.push(elm);
                }
            });
        });
    }

    if(!models.length) {
        return false;
    }
    
    return {
        Bezeichnung_1: "Spanne",
        Typ: "RANGE",
        VerbrauchKombiniert: calcValues("VerbrauchKombiniert", models),
        VerbrauchKombiniertWLTP: calcValues("VerbrauchKombiniertWLTP", models),
        VerbrauchKombiniertElektrisch: calcValues("VerbrauchKombiniertElektrisch", models),
        VerbrauchKombiniertElekWLTP:  calcValues("VerbrauchKombiniertElekWLTP", models),
        CO2: calcValues("CO2", models),
        CO2WLTP: calcValues("CO2WLTP", models),
        ReichweiteElekWLTP: calcValues("ReichweiteElekWLTP", models),
        ReichweiteElekCityWLTP: calcValues("ReichweiteElekCityWLTP", models),
        Energieklasse: calcPlakette(models)
    }
}
*/

export const getConsumptions = (model, consumptions) => {
	if(!model.KCD || !consumptions.content) {
		return false;
	}
    const values = {};
	const kcds = model.KCD;
	const elms = consumptions.content.elements;
	
	for(let key in kcds) {
		values[key] = [];
		kcds[key].forEach(kcd => {
			for(let i = 0; i < elms.length; i++) {
				elms[i].KeyConsumptionData === kcd &&	// check if kcd key exists
				elms[i].ModellTyp === key && 	// check if model type matches
				values[key].push(elms[i]);
			}
		});
	}
	
	// delete types with empty array >> no entry in consumptions
	for(let key in values) {
		if(!values[key].length) {
			delete values[key];
		}
	}
	
	return values;
}

export const findByKCD = (consumptions, kcd) => {
	const elms = (consumptions.content && consumptions.content.elements) || [];
	
	for(let i = 0; i < elms.length; i++) {
		if(elms[i].KeyConsumptionData === kcd) {
			return elms[i];
		}
	}
	return false;
}

export const encodeKCD = (decoded) => {
	let encoded = [];
	for(let id in decoded) {
		for(let type in decoded[id]) {
			encoded = decoded[id][type].length && encoded.concat(decoded[id][type]);
		}
	}
	return encoded.join(',');
}

export const decodeKDC = (models, consumptions, value) => {
	const decoded = {};
	const kcds = (value && value.replaceAll(';',',').split(',')) || [];
	const elms = (consumptions.content && consumptions.content.elements) || [];
	
	const findTypeByKDC = (kcd) => {
		for(let i = 0; i < elms.length; i++) {
			if(elms[i].KeyConsumptionData === kcd) {
				return elms[i].ModellTyp;
			}
		}
		return false;
	};
	
	const findModelByKCD = (kcd) => {
		for(let id in models) {
			for(let type in models[id].KCD) {
				for(let i = 0; i < models[id].KCD[type].length; i++) {
					if(models[id].KCD[type][i] === kcd) {
						return id;
					}
				}
			}
		}
		return false;
	};
	
	kcds.forEach(kcd => {
        console.log(kcd);
		const model = findModelByKCD(kcd);
		const type = findTypeByKDC(kcd);
		if(model && type) {
			if(!decoded[model]) {
				decoded[model] = {};
			}
			if(!decoded[model][type]) {
				decoded[model][type] = [];
			}
			decoded[model][type].push(kcd);
		}
	});
	
	return decoded;
}

export const checkMissmatch = (models, consumptions) => {
    const missmatch = { porschemodelle: [], verbrauchswerte: [] };
    let elms = (consumptions.content && consumptions.content.elements) || [];
    elms = elms.filter(elm => {
        // removed all model ranges
        return elm.Vorlage.indexOf("baureihe") === -1;
    })
   
    // create elms kcds
    const elmsKcds = elms.map(elm => { return elm.KeyConsumptionData });
    
    // create models kcds
    const modelsKcds = [];
    Object.values(models).forEach(model => {
        const kcds = model.KCD;

        for(let key in kcds) {
            kcds[key].forEach(kcd => {
                modelsKcds.push(kcd);
            });
        }
    });
    
    for(let i = 0; i < elmsKcds.length; i++) {
        !modelsKcds.includes(elmsKcds[i]) && missmatch.verbrauchswerte.push(elmsKcds[i]);
    }
    
    for(let i = 0; i < modelsKcds.length; i++) {
        !elmsKcds.includes(modelsKcds[i]) && missmatch.porschemodelle.push(modelsKcds[i]);
    }
    
    return missmatch;
}
